export const sendId = async(id, fetchApi, headers, url) => {
    console.log(id, fetchApi, headers, url)
    const response = await fetchApi({
        url: url + '/utils/cupos',
        headers: headers,
        content: {
            IdSolicitud: id,
        }
    })
    return [response.msg[0]['Estado'], response.msg[0]['Mensaje']]
} 